<template>
	<div class="text-justify">
		<div class="row">
			<!-- Assign Schedule -->
			<div class="col-lg-12">
				<student-profile-tab-schedule-assign-schedule-table
					:scheduleRecommendationTableHideFunc="
						scheduleRecommendationTableHideFunc
					"
					:scheduleRecommendationTableHideVal="
						scheduleRecommendationTableHideVal
					"
					:value="value"
				/>
			</div>

			<!-- Schedule Recommendations -->
			<div
				class="col-lg-12 mt-8"
				v-if="scheduleRecommendationTableHideVal"
			>
				<student-profile-tab-schedule-schedule-recommendation-table
					:assignScheduleRowData="assignScheduleRowData"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import GlobalHelperMixin from "../../../../../../../Mixins/global/GlobalHelperMixin";

export default {
	name: "StudentTabSchedule",
	mixins: [FormMixin, GlobalHelperMixin],
	props: {
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			scheduleRecommendationTableHideVal: false,
			assignScheduleRowData: {},
			sameAsAbove: false,
			scheduleForm: {
				reference_id: "",
				name: "",
				status: "",
				to_be_completed_by: "",
				clc_id_number: "",
				sub_status: "",
				class_name: "",
				assigned_date: "",
				expired_date: "",
				assigned_by: "",
			},
		};
	},
	methods: {
		scheduleRecommendationTableHideFunc(value, data) {
			this.assignScheduleRowData = data;
			this.scheduleRecommendationTableHideVal = value;
		},
		submitScheduleForm() {
			// Logic for submitting Schedule form.
			// Access data using this.scheduleForm.

			// For example, you can log the data to the console:
			console.log("Schedule Form:", this.scheduleForm);

			// You can also make an API request to submit the data if needed.
		},
		clearScheduleForm() {
			// Clear Schedule form fields.
			for (let key in this.scheduleForm) {
				this.scheduleForm[key] = "";
			}
		},
	},
	watch: {},
};
</script>

<style scoped>
.ml-40 {
	margin-left: 40px; /* You can adjust the margin value as needed */
}
.mr-40 {
	margin-right: 40px !important; /* You can adjust the margin value as needed */
}
.mt-8 {
	margin-top: 80px;
}
.mb-8 {
	margin-bottom: 40px;
}
.form-control {
	border: 3px solid; /* You can adjust the border color and width as needed = #c41a1a !important; */
}
.required-star {
	color: red;
}
</style>
